import { render, staticRenderFns } from "./AccountListTable.vue?vue&type=template&id=b820ff94&scoped=true&"
import script from "./AccountListTable.vue?vue&type=script&lang=js&"
export * from "./AccountListTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountListTable.vue?vue&type=style&index=0&id=b820ff94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b820ff94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
